import React from "react";
import "./SideNav.css";
import logo from "../logo.png";
import {
  BsCalendar,
  BsCollection,
  BsFileBarGraph,
  BsPen,
  BsPeople,
  BsPerson,
} from "react-icons/bs";
import { SiMinutemailer } from "react-icons/si";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import {
  BiChevronLeft,
  BiChevronRight,
  BiCog,
  BiCollapseHorizontal,
  BiCollapseVertical,
  BiLogOutCircle,
  BiMenu,
  BiMoney,
} from "react-icons/bi";
import { Link, NavLink } from "react-router-dom";
import { IoTicketOutline } from "react-icons/io5";

const accounttype = localStorage.getItem("accounttype");

// Navigation config
const NAV_ITEMS = {
  top: [
    {
      label: "Dashboard",
      icon: <BsFileBarGraph size={20} />,
      key: "customerdashboard",
    },
    { label: "Events", icon: <BsCalendar size={20} />, key: "./" },
    { label: "Tickets", icon: <IoTicketOutline size={20} />, key: "tickets" },
    {
      label: "Transactions",
      icon: <BiMoney size={20} />,
      key: "transactions-view",
    },
    { label: "Feedback", icon: <BsPen size={20} />, key: "feedback" },
  ],
  bottom: [
    { label: "My Account", icon: <BsPerson size={20} />, key: "profile" },
    { label: "Logout", icon: <BiLogOutCircle size={20} />, key: "logout" },
  ],
};

const SideNavCust = ({ collapsed, onToggle, onNavigate }) => {
  const handleLogout = async () => {
    try {
      await fetch("https://karamale.com/apps/kscanner/logout.php", {
        method: "GET",
        credentials: "include", // sends cookies like sessionId
      });

      // Clear local data and redirect
      localStorage.clear();
      window.location.href = "/login";
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const renderNavItems = (items) =>
    items.map(({ key, label, icon }) => (
      <NavLink
        to={label === "Events" ? `./${key}` : `/${key}`}
        onClick={key === "logout" ? handleLogout : ""}
        style={{ textDecoration: "none", color: "inherit" }}
        className="links font-normal"
        exact
        activeClassName="activeLink"
      >
        <li key={key} className="nav-item">
          <span className="nav-icon">{icon}</span>
          {!collapsed && <label className="nav-label mb-0">{label}</label>}
        </li>
      </NavLink>
    ));

  return (
    <nav className={`side-nav ${collapsed ? "collapsed" : ""}`}>
      <header className="nav-header" onClick={onToggle}>
        {collapsed ? (
          <label className="mb-3 relative">
            <img src={logo} alt="Karamale" width={30} />
          </label>
        ) : (
          <label className="nav-brand-label mb-3 w-100">
            <img src={logo} alt="Karamale" width={30} />
            &nbsp;&nbsp;
            <span className="nav-brand">Karamale</span>
            <span className="float-right cursor-pointer">
              <BiChevronLeft size={25} />
            </span>
          </label>
        )}
      </header>

      <ul className="nav-list top-nav">{renderNavItems(NAV_ITEMS.top)}</ul>
      <ul className="nav-list bottom-nav">
        {renderNavItems(NAV_ITEMS.bottom)}
      </ul>
    </nav>
  );
};

export default SideNavCust;
